// @react
import React, { ReactElement } from 'react'
// @types
import { GetUserQuery, GetUserQueryVariables } from 'lib/graphql/graphqlTypes'
// @graphQL
import { useQuery } from '@apollo/client'
import { GET_USER } from 'graphql/queries/user.query'
// @module components
import ProfileForm from 'modules/onBoarding/components/Profile/Form'
import QueryError from 'modules/common/components/Errors/QueryError'

const ProfileContainer = (): ReactElement => {
  /******************************************
   * HOOKS
   ******************************************/

  const { loading: isLoading, error: isError, data, refetch } = useQuery<
    GetUserQuery,
    GetUserQueryVariables
  >(GET_USER, { fetchPolicy: 'cache-first' })

  /******************************************
   * RENDER
   ******************************************/

  if (isError || (!isLoading && !data)) return <QueryError />

  return <ProfileForm data={data} isLoading={isLoading} refetch={refetch} />
}

export default ProfileContainer
